export default "__VITE_ASSET__BR9iy6zs__"